const knownSubRoutes = {
  flights: [
    "search",
    "shop",
    "book",
    "confirm",
    "change",
    "disruption-offer",
    "ancillary",
  ],
  hotels: ["search", "availability", "shop", "book", "confirm", "ancillary"],
  stays: ["search", "availability", "shop", "book", "confirm"],
  cars: ["search", "availability", "shop", "book", "confirm"],
  trips: ["disruption", "change", "refund"],
  "premium-stays": [
    "search",
    "availability",
    "shop",
    "book",
    "confirm",
    "ancillary",
    "vibes",
    "vacation-rentals",
  ],
  packages: [
    "search",
    "hotels-availability",
    "hotel-shop",
    "flight-shop",
    "review",
    "book",
    "confirm",
  ],
  "hotels-flights": [
    "search",
    "hotels-availability",
    "hotel-shop",
    "flight-shop",
    "review",
    "book",
    "confirm",
  ],
  "vacation-rentals": ["search", "availability", "shop", "book", "confirm"],
  activities: ["search", "availability", "shop", "book", "confirm"],
  exchange: ["flight", "shop", "confirm", "book"],
  auth: ["ftux", "startsession", "invalidsession"],
  terms: ["cancel-for-any-reason", "travel-credits"],
  admin: [],
  profile: [],
  favorites: [],
  "travel-offers": [],
  business: [],
} as const;

/**
 * Maps a URL pathname to a simplified tracking entry point value.
 *
 * @param pathname - The URL pathname (e.g., "/stays/availability/nyc")
 * @returns A simplified tracking value (e.g., "stays_availability")
 */
export const getTrackingEntryPoint = (pathname: string): string => {
  const normalizedPath = pathname.replace(/^\/|\/$/g, "").toLowerCase();

  const segments = normalizedPath.split("/");

  if (segments.length === 0 || segments[0] === "") {
    return "home";
  }

  const category = segments[0];

  if (!(category in knownSubRoutes)) {
    return category;
  }

  if (segments.length === 1) {
    return category.replace(/-/g, "_");
  }

  const subRoutes = knownSubRoutes[category];
  for (const segment of segments.slice(1)) {
    if (subRoutes.includes(segment)) {
      return `${category}_${segment}`.replace(/-/g, "_");
    }
  }

  if (segments.length > 1 && segments[1]) {
    return `${category}_${segments[1]}`.replace(/-/g, "_");
  }

  return category.replace(/-/g, "_");
};
